export default __webpack_public_path__ + "static/media/schedularLeft.e0a9263f.svg";